import {
  ADD_USER_SELECTED,
  REMOVE_USER_SELECTED,
  RESET_USERS_SELECTED
} from "../actions/action-types";

export const usersSelectedReducer = (state = [], action) => {
  if (action.type === ADD_USER_SELECTED) {
    return [...state, action.idUser];
  }
  if (action.type === REMOVE_USER_SELECTED) {
    const listUsersSelected = [...state];
    const refreshedList = listUsersSelected.filter(
      element => element !== action.idUser
    );
    return refreshedList;
  }
  if (action.type === RESET_USERS_SELECTED) {
    return [];
  }
  return state;
};
